module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxNSAyMzIuOG0tMTY3LjcgMGExNjMuOSAxNjMuOSAwIDEgMCAzMzUuNSAwIDE2My45IDE2My45IDAgMSAwLTMzNS41IDBaTTgyMy42IDk5MS40IDIwMC40IDk5MS40IDM0Ny4yIDQxOC44IDY4Mi43IDQxOC44WiIgcC1pZD0iMTAwNiI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/person.svg
// module id = vxuN
// module chunks = 74